import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {NodeClassImpl} from "#template/runtime-graph/types"

const TD = TypeDescriptors

const branchDescriptor = {
    input: TD.inlet(TD.Identity<any>()),
    true: TD.outlet(TD.Identity<any>()),
    false: TD.outlet(TD.Identity<any>()),
}

export class Branch<T> implements NodeClassImpl<typeof branchDescriptor, typeof Branch> {
    static descriptor = branchDescriptor
    static uniqueName = "Branch"
    input!: Inlet<T>
    true!: Outlet<T>
    false!: Outlet<T>

    run() {
        if (this.input === NotReady) {
            this.true.emitIfChanged(NotReady)
            this.false.emitIfChanged(NotReady)
            return
        } else if (this.input === null || this.input === undefined) {
            this.true.emitIfChanged(NotReady)
            this.false.emitIfChanged(this.input)
        } else {
            this.true.emitIfChanged(this.input)
            this.false.emitIfChanged(NotReady)
        }
    }
}
